// libraries.
import { electricPurple600 } from '@habitech/shared';

export type PolygonType = 'standard' | 'blocking';

// STANDARD_POLYGON_STYLE is the creation/edit-time color (mirror of DrawingPolygon.tsx).
// List-time rendering of EXISTING polygons keeps using optionsPolygons.ts (skyBlue) — do not refactor that to use this constant.
export const STANDARD_POLYGON_STYLE = {
  fillColor: electricPurple600,
  fillOpacity: 0.5,
  strokeColor: electricPurple600,
  strokeOpacity: 0.8,
  strokeWeight: 2,
};

// Phase 5 D-02: post-save visibility tuning for blocking polygons.
// fillOpacity 0.3 → 0.45 (más opaco en el render desde GET; UAT FINDING).
// strokeColor #C41E3A → #A71D2A (un shade más oscuro; mayor contraste con el fill).
export const BLOCKING_POLYGON_STYLE = {
  fillColor: '#DC3545', // sin cambio (Bootstrap danger; mantiene paridad con Badge "Bloqueo")
  fillOpacity: 0.45, // antes 0.3 — más visible cuando se rendea desde GET (UAT FINDING)
  strokeColor: '#A71D2A', // antes #C41E3A — un shade más oscuro, mayor contraste con el fill
  strokeOpacity: 1,
  strokeWeight: 3,
};

/**
 * Returns the Google Maps polygon style for a given polygon_type.
 * Falls back to STANDARD when polygon_type is undefined (retrocompat per D-06):
 * polygons created pre-Phase-1 come without the field and must render as standards.
 */
export const getPolygonStyle = (polygon_type?: PolygonType) =>
  polygon_type === 'blocking' ? BLOCKING_POLYGON_STYLE : STANDARD_POLYGON_STYLE;
